module.exports = __webpack_public_path__ + "media/usp-mealplans-28bdd983.svg";